import { render, staticRenderFns } from "./StorageBaseFireBase.vue?vue&type=template&id=64c53f88&"
import script from "./StorageBaseFireBase.vue?vue&type=script&lang=js&"
export * from "./StorageBaseFireBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports